import { Vision360BodyMap2D } from "./Vision360BodyMap2D";
import type { BodyMarker } from "@/types/vision360";

interface Vision360BodyMapProps {
  markers: BodyMarker[];
  sex?: "M" | "F" | string | null;
  onMarkerClick?: (marker: BodyMarker) => void;
}

export function Vision360BodyMap({ markers, sex, onMarkerClick }: Vision360BodyMapProps) {
  return (
    <Vision360BodyMap2D
      markers={markers}
      sex={sex}
      onMarkerClick={onMarkerClick}
    />
  );
}
